import rootPath from "../routes-path";

export { RouteProps } from "../routes-path";

export default rootPath + "/pary";